// extracted by mini-css-extract-plugin
module.exports = {"gray":"DisplaySection_gray__IOWt9","white":"DisplaySection_white__1EKuX","borders":"DisplaySection_borders__1f62i"};